import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryAPI } from '../../utilities/apiEndpointUtility';

import {
	shipmentInformation,
	shipmentInformationCompleted,
	shipmentInformationFailed
} from './shipmentInformationSlice';
import { handleAxiosError } from '../../utilities/errorUtility';

const shipmentInformationEpic = (action$) =>
	action$.pipe(
		ofType(shipmentInformation),
		mergeMap(async (action) => {
			try {
				const kitShipmentProcessing = action.payload;
				const response = await axios.post(
					`${primaryAPI()}/kit-shipment/subscriber/shipping-email-confirmation`,
					kitShipmentProcessing
				);
				return response.data;
			} catch (error) {
				handleAxiosError(error?.response?.status);
			}
		}),
		switchMap((res) => [shipmentInformationCompleted(res)]),
		catchError((error, source) =>
			merge(of(shipmentInformationFailed(error.message)), source)
		)
	);

export default [shipmentInformationEpic];
